import { ExporPiListSortField } from "@saleor/createOrderExport/urls";
import { ExportPIsSortField } from "@saleor/graphql";
import { createGetSortQueryVariables } from "@saleor/utils/sort";

export function getSortQueryPiNoField(
  sort: ExporPiListSortField
): ExportPIsSortField {
  switch (sort) {
    case ExporPiListSortField.piNo:
      return ExportPIsSortField.CODE;
    default:
      return undefined;
  }
}

export const getSortQueryPiVariables = createGetSortQueryVariables(
  getSortQueryPiNoField
);
